<template>
    <div v-if="team && team.role == 'owner'">
        <div class="alert alert-danger" v-if="errorMessage != ''">
            {{ errorMessage }}
        </div>
        <div class="d-flex align-items-end mb-3">
            <div class="form-group mb-0 mr-3" v-if="team.group_id">
                <label for="inviteTo" class="category-title">Invite To</label>
                <select
                    class="form-control"
                    v-model="invitationType"
                    id="inviteTo"
                >
                    <option value="team">{{ team.name }}</option>
                    <option value="group">{{ team.group_name }} (Group)</option>
                </select>
            </div>
            <div class="form-group mb-0 mr-3">
                <label for="role" class="category-title">Role</label>
                <select class="form-control" id="role" v-model="role">
                    <option value="member">Member</option>
                    <option value="owner">Owner</option>
                </select>
            </div>
            <div class="form-group col px-0 mb-0 mr-3">
                <label for="email" class="category-title">Email</label>
                <input
                    type="text"
                    id="email"
                    class="form-control"
                    v-model="email"
                    placeholder="Enter email"
                />
            </div>
            <div>
                <button
                    type="button"
                    @click="invite"
                    class="btn btn-primary"
                    :disabled="adding || email.length < 4"
                >
                    <span v-if="adding"><i class="fa fa-btn fa-spinner fa-spin"></i> Inviting..</span>
                    <span v-else>Invite Now</span>
                </button>
            </div>
        </div>
        <div v-if="currentMembers != null">
            <table class="table" v-if="currentMembers != null">
                <thead>
                    <tr>
                        <th>Email</th>
                        <th>Name</th>
                        <th>Role</th>
                    </tr>
                </thead>

                <tbody>
                    <tr v-for="user in currentMembers.users" :key="user.id">
                        <td>{{ user.email }}</td>
                        <td>{{ user.name }}</td>
                        <td>{{ ucFirst(user.pivot.role) }}</td>
                    </tr>
                    <tr v-if="currentMembers.invitations.length > 0">
                        <th colspan="3" scope="row">Invitations</th>
                    </tr>
                    <tr
                        v-for="invitation in currentMembers.invitations"
                        :key="invitation.id"
                    >
                        <td>{{ invitation.email }}</td>
                        <td></td>
                        <td>{{ ucFirst(invitation.role) }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        team: Object
    },
    data() {
        return {
            invitationType: "team",
            email: "",
            role: "member",
            adding: false,
            errorMessage: "",
            currentMembers: null,
            startPath: '/',
        };
    },
    computed: {
        isGf() {
            // return window.location.pathname.includes('extension');
            return false;
        },
    },
    mounted() {
        this.startPath = window.location.pathname.includes('extension') ?
            `${window.location.origin + '/extension'}` : `${window.location.origin}`;
        this.getCurrent();
    },
    methods: {
        getCurrent() {
            axios.get(`${this.startPath}/teams/${this.team.id}/users`).then(response => {
                this.currentMembers = response.data;
            });
        },
        invite() {
            if (!this.email.includes("@")) {
                swal("danger", "Not a valid email");
                return;
            }
            const postData = {
                email: this.email,
                role: this.role,
                method: this.isGf ? 'guestflip' : 'clickhint'
            };
            if (this.invitationType == "group") {
                postData.groupId = this.team.group_id;
            }
            this.adding = true;
            axios
                .post(`${this.startPath}/teams/${this.team.id}/add-user`, postData)
                .then(response => {
                    this.adding = false;
                    this.email = '';
                    this.getCurrent();
                })
                .catch(error => {
                    this.adding = false;
                    this.errorMessage = error.response.message
                        ? error.response.message
                        : "Something went wrong.";
                });
        }
    }
};
</script>
